import { render } from "./GroupDetailsCL.vue?vue&type=template&id=3b264862"
import script from "./GroupDetailsCL.vue?vue&type=script&lang=js"
export * from "./GroupDetailsCL.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__